let dd = console.debug.bind(console);
export default dd;



// WEBPACK FOOTER //
// ./src/utils/dd.js